import CollapsibleSection from '../CollapsibleSection';
import { Typography } from '@weareopenr/component-library';
import styles from 'src/components/PriceRuleFlowShared/PriceRule.module.scss';

type RuleType = 'price_band' | 'external_system';
type PriceEntity = { id: string; name: string };

type Props = {
  name: string;
  entityType: RuleType;
  selected: PriceEntity[];
  calculationSubtitle: string;
  roundingSubtitle: string;
};

const PriceRuleOverview = ({ name, entityType, selected = [], roundingSubtitle, calculationSubtitle }: Props) => {
  const entityTitle = entityType === 'price_band' ? 'Price Band' : 'Channel';
  const entitySubtitle = entityType === 'price_band' ? 'venue(s)' : 'channel(s)';
  const selectedCount = selected.length;

  return (
    <>
      <Typography className={styles['title']} size="xxlarge" weight="semi-bold">
        Summary for <b>{name}</b>
      </Typography>
      <div className={styles['collapsible-container']}>
        <CollapsibleSection
          number="1"
          title={`${entityTitle} Allocation`}
          subtitle={`${selectedCount} ${entitySubtitle} selected`}
        >
          <ul>
            {selected.map(({ name, id }) => (
              <li key={id}>{name}</li>
            ))}
          </ul>
        </CollapsibleSection>
        <CollapsibleSection number="2" title="Calculation" subtitle={calculationSubtitle} />
        <CollapsibleSection number="3" title="Rounding" subtitle={roundingSubtitle} />
      </div>
    </>
  );
};

export default PriceRuleOverview;
